var map = {
	"./bk/carousel-1.png": "84ab",
	"./bk/carousel-2.png": "6b4b",
	"./bk/carousel-3.png": "ccfe",
	"./bk/carousel-4.jpg": "00ca",
	"./bk/carousel-5.jpg": "a396",
	"./bk/carousel-6.jpg": "0ddc",
	"./bk/rsi-aris.png": "19db",
	"./bk/rsi-logo.jpg": "ff2a",
	"./icons/calimax.jpg": "90ac",
	"./icons/sams.png": "1f16",
	"./icons/target.png": "4ab9",
	"./icons/walmart.png": "fd15",
	"./imgs/data-availability-005.jpg": "3687",
	"./imgs/data-availability-006.jpg": "6517",
	"./imgs/data-availability-3.jpg": "a500",
	"./imgs/data.png": "6b57",
	"./imgs/events-1.jpg": "e39e",
	"./imgs/events.png": "b284",
	"./imgs/hub.png": "ed53",
	"./imgs/knowledge-003.jpg": "7033",
	"./imgs/knowledge-7.jpeg": "a9da",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";